import { BaseComponent } from '../../components/base-component'
import { CartPage } from './cart'
import { replaceNodeChildren } from '../../utils/dom'
import { $el, $elParent, isNotThemeStore } from 'src/scripts/utils/utils'

const CART_PAGE_SELECTOR = 'cart-page'

export class CartItemsBlock extends BaseComponent {
  mountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.on('update-nodes', this.handleCartUpdate)
  }

  unmountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.off('update-nodes', this.handleCartUpdate)
  }

  handleCartUpdate = ({ node }): void => {
    replaceNodeChildren(
      this,
      $el(
        `cart-items-block[block-id="${this.getAttribute('block-id')}"]`,
        node,
      ),
    )

    if (isNotThemeStore()) {
      this.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
